import { createSlice } from '@reduxjs/toolkit'

export const noteSlice = createSlice({
  name: 'note',
  initialState: {
    value: undefined,
  },
  reducers: {
    storeNote: (state, action) => {
      state.value = action.payload
    },
    cleanNote: (state) => {
        state.value = undefined;
    }
  },
})
export const { storeNote, cleanNote } = noteSlice.actions

export default noteSlice.reducer